import React, { PropTypes } from 'react';
import Rubrik from './PageComponents/Rubrik/Rubrik';
import Text from './PageComponents/Text/Text';
import Ingress from './PageComponents/Ingress/Ingress';
import Ingressmulti from './PageComponents/Ingressmulti/Ingressmulti';
import Citat from './PageComponents/Citat/Citat';
import Video from './PageComponents/Video/Video';
import Bild from './PageComponents/Bild/Bild';
import Special from './PageComponents/Special/Special';
import Iframe from './PageComponents/Iframe/Iframe';
import Luft from './PageComponents/Luft/Luft';
import Linje from './PageComponents/Linje/Linje';
import Fakta from './PageComponents/Fakta/Fakta';
import Faktavit from './PageComponents/Faktavit/Faktavit';
import Lista from './PageComponents/Lista/Lista';
import Sharebuttons from './PageComponents/Sharebuttons/Sharebuttons';
import Usagrafik from './PageComponents/Usagrafik/usagrafik';
import Noscript from './PageComponents/Noscript/Noscript';
import Wrapper from './PageComponents/Wrapper';
import Div from './PageComponents/Div';
import BildVr from './PageComponents/BildVR/BildVR';
import Flipper from './PageComponents/Flipper';
import VideoTag from './PageComponents/VideoTag';
import VideoBg from './PageComponents/VideoBg';
import Quiz from './PageComponents/InfoQuiz/Quiz';

const PageComponent = ({ type, value, children }) => {
  const lctype = type.toLowerCase();
  if (lctype.indexOf('rubrik') >= 0) {
    return <Rubrik type={type} value={value}/>;
  }
  else if (lctype === 'text') {
    return <Text>{value}</Text>;
  }
  else if (lctype === 'ingress') {
    return <Ingress>{value}</Ingress>;
  }
  else if (lctype === 'ingressmulti') {
    return <Ingressmulti>{value}</Ingressmulti>;
  }
  else if (lctype === 'citat') {
    return <Citat value={value}/>;
  }
  else if (lctype === 'video') {
    return <Video value={value}/>;
  }
  else if (lctype === 'bild') {
    return <Bild {...value}/>;
  }
  else if (lctype === 'bildvr') {
    return <BildVr value={value}/>;
  }
  else if (lctype === 'iframe') {
    return <Iframe value={value}/>;
  }
  else if (lctype === 'special') {
    return <Special value={value}/>;
  }
  else if (lctype === 'luft') {
    return <Luft value={value}/>;
  }
  else if (lctype === 'linje') {
    return <Linje value={value}/>;
  }
  else if (lctype === 'fakta') {
    return <Fakta value={value}/>;
  }
  else if (lctype === 'faktavit') {
    return <Faktavit value={value}/>;
  }
  else if (lctype === 'usagrafik') {
    return <Usagrafik value={value}/>;
  }
  else if (lctype === 'noscript') {
    return <Noscript value={value}/>;
  }
  else if (lctype.startsWith('lista')) {
    return <Lista type={lctype} value={value}/>;
  }
  else if (lctype === 'sharebuttons') {
    return <Sharebuttons title={value.title} url={value.url} />;
  }
  else if (lctype.indexOf('wrapper') >= 0) {
    return <Wrapper type={lctype} value={value}>{children}</Wrapper>;
  }
  else if (lctype.indexOf('div') >= 0) {
    return <Div value={value} />;
  }
  else if (lctype.indexOf('flipper') >= 0) {
    return <Flipper value={value} />;
  }
  else if (lctype === 'videotag') {
    return <VideoTag value={value} />;
  }
  else if (lctype === 'videobg') {
    return <VideoBg value={value} />;
  }
  else if (lctype === 'quiz') {
    return <Quiz value={value} />;
  }
  return <div style={{color: 'red', fontSize:'24px'}}>Unknown component: "{lctype}", value:{JSON.stringify(value)}</div>;
};

PageComponent.propTypes = {
  type: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
    PropTypes.array
  ])
};

export default PageComponent;



/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/components/Page/_PageComponent.js
 **/